import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvChemistryNgLibModule } from 'sv-chemistry-ng-lib';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { CatalogTableComponent } from './catalog-table/catalog-table.component';
import { OrderTableComponent } from './order-table/order-table.component';
import { RouterModule } from '@angular/router';
import { ComponentRoutes } from './components.routing';
import {searchPipe} from './../shared/util/search.pipe';
import { LogoutPageComponent } from './logout-page/logout-page.component';
import { UserErrorModalComponent } from './user-error-modal/user-error-modal.component';

@NgModule({
  imports: [
    CommonModule,
    SvChemistryNgLibModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    RouterModule.forRoot(ComponentRoutes)
  ],
  declarations: [
    CatalogTableComponent, 
    OrderTableComponent,
    searchPipe,
    LogoutPageComponent,
    UserErrorModalComponent
  ],
  exports: [
    CatalogTableComponent, 
    OrderTableComponent,
    LogoutPageComponent,
    UserErrorModalComponent
  ]
})
export class ComponentsModule { }
